import { Container } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles";


export const color = {
  menuBackground: "#120D2B",
  mainBackground: "#eff0ed",
  tableBackground: "#11111d",
  tableHeader: "#29184e",
  inputBorder: "#2d2884",
  inputBackground: "#211638",
  drawerMenuBackground: "#19123c",
  drawerMenuActiveBackground: "#130d2f",
  dialogBackground: "#222e53",
  white: "#FFF",
  primary: "#5cddfd",
  black: '#000',
  red: "#d52913",
};

export const font = {
  smallSize: '10px',
  smallSize__mobile: "1.55vw",
  nomalSize: "16.5px",
  nomalSize__mobile: "2vw",
  largeSize: "26.0px",
  largeSize__mobile: "3.3vw",
  bigSize: '30px',
  bigSize__mobile: '4vw',
  boldFamily: "CenturyGothicBold",
};

export const layout = {
  headerHeight: "75px",
  headerHeight__mobile: "13.6vw",
  footerHeight: "90px",
  headerHeighBg: `calc(100vw / 1920 * 480)`,
  headerHeighBg__mobile: `calc(100vw / 1920 * 760)`,
  headerHeighHomeBg: `calc(100vw / 1920 * 200)`,
  headerHeighHomeBg__mobile: `calc(100vw / 1920 * 340)`,
};


export const StyledContainer = withStyles(theme => ({
  root: {
    maxWidth: '1180px',
    margin: 'auto',
    padding: '0 20px',
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
      margin: '0px',
    },
  },
}))(Container);

export const StyledContainerFooter = withStyles(theme => ({
  root: {
    maxWidth: '1180px',
    // margin: 'auto',
    minHeight: '70px',
    padding: '0 20px',
    // backgroundColor: '#dcdcda',
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
      margin: '0px',
    },
  },
}))(Container);
